/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Workflow_Learnmore1Inputs */

const zh_landing_workflow_learnmore1 = /** @type {(inputs: Landing_Workflow_Learnmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`了解更多`)
};

const en_landing_workflow_learnmore1 = /** @type {(inputs: Landing_Workflow_Learnmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn more`)
};

const es_landing_workflow_learnmore1 = /** @type {(inputs: Landing_Workflow_Learnmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saber más`)
};

/**
* | output |
* | --- |
* | "Learn more" |
*
* @param {Landing_Workflow_Learnmore1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_workflow_learnmore1 = /** @type {((inputs?: Landing_Workflow_Learnmore1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Workflow_Learnmore1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_workflow_learnmore1(inputs)
	if (locale === "en") return en_landing_workflow_learnmore1(inputs)
	return es_landing_workflow_learnmore1(inputs)
});
export { landing_workflow_learnmore1 as "landing_workflow_learnMore" }